module.exports = __webpack_public_path__ + "static/media/ic-3.8701eb70.svg";